import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;    
};

const CarPositionIconVertical = ({ width = 30, height = 42, color = 'currentColor', ...props }: Props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 30 42" fill="none" {...props}>
            <path d="M15 0C23.2843 0 30 7.05152 30 15.75C30 25.6079 18.6313 38.1965 15.6885 41.29L15.6152 41.3604C15.2587 41.6657 14.7413 41.6657 14.3848 41.3604L14.3115 41.29C11.3687 38.1965 0 25.6079 0 15.75C0 7.05152 6.71573 0 15 0ZM15 2C7.91113 2 2 8.06301 2 15.75C2 20.0377 4.53063 25.2174 7.71094 29.9395C10.3719 33.8904 13.304 37.2551 15 39.0967C16.696 37.2551 19.6281 33.8904 22.2891 29.9395C25.4694 25.2174 28 20.0377 28 15.75C28 8.06301 22.0889 2 15 2ZM16.041 8.7998C19.17 8.7998 21.1445 10.6274 21.1445 13.6514C21.1444 16.6961 19.2119 18.4814 15.999 18.4814H13.1221V23.5H10.0146V8.7998H16.041ZM13.1221 15.625H15.957C17.196 15.625 18.0361 14.8689 18.0361 13.6299C18.0361 12.286 17.3223 11.6348 15.9785 11.6348H13.1221V15.625Z" fill={color} />
        </svg>
    );
};

export default CarPositionIconVertical;
